
<i [class]='helpIcon' [ibHelpPopup] = 'helpTopic' title='{{title}}'></i>
